/* eslint-disable */
//tslint:disable

import { IListingLinksSchema } from '../listing_links/ListingLinksSchema';
import { ILKLinksSchema } from '../lk_links/LKLinksSchema';
import { IMagazineLinksSchema } from '../magazine_links/MagazineLinksSchema';
import { IMortgageLinksSchema } from '../mortgage_links/MortgageLinksSchema';
import { IOtherLinksSchema } from '../other_links/OtherLinksSchema';
import { IUserVerificationSchema } from '../user_verification/UserVerificationSchema';

export interface IHeaderV1Schema {
  /** Ссылка на каталог специалистов **/
  agentsUrl: string;
  /** Ссылка на аватарку пользователя **/
  avatarUrl?: string | null;
  /** Баланс **/
  balance?: number | null;
  /** Ссылка на каталог БЦ **/
  bcUrl?: string | null;
  /** Имя пользователя для отображения **/
  displayUsername?: string | null;
  /** Емайл пользователя **/
  email?: string | null;
  /** Количество избранных объявлений **/
  favoritesCount: number;
  /** Имя пользователя **/
  firstName?: string | null;
  /** Аутентифицирован ли пользователь **/
  isAuthenticated: boolean;
  /** Флаг доступности БЦ в данном регионе **/
  isBcRegion: boolean;
  /** Партнёр ЦИАН **/
  isCianPartner: boolean;
  /** Включена ли проверка ограничений **/
  isModerationVerificationEnabled: boolean;
  /** Является ли пользователь профи **/
  isProfi: boolean;
  /** Флаг доступности ТЦ в данном регионе **/
  isScRegion: boolean;
  /** Флаг доступности СК в данном регионе **/
  isWcRegion: boolean;
  /** Ссылка на каталог ЖК **/
  jksNewobjectsUrl: string;
  /** Ссылка на выдачу в новостройках **/
  jksSaleUrl: string;
  /** Ссылка на выдачу загородной **/
  kpUrl: string;
  /** Контрольная сумма пользователя для чата webim КпН (Консультантов по Новостройкам) **/
  kpnWebimChecksum?: string | null;
  /** Фамилия пользователя **/
  lastName?: string | null;
  /** Количество новых заявок в сервисе demand для специалиста **/
  leadsCount?: number | null;
  /** Ссылки на личный кабинет **/
  listingLinks?: IListingLinksSchema | null;
  /** Урл раздела "Операции" личного кабинета **/
  lkBalanceUrl?: string | null;
  /** Ссылки на личный кабинет **/
  lkLinks?: ILKLinksSchema | null;
  /** Тип личного кабинета пользователя **/
  lkType?: ELkType | null;
  /** Деградировали ли мы типом ЛК **/
  lkTypeDegrade: boolean;
  /** Урл личного кабинета **/
  lkUrl?: string | null;
  /** Ссылки на ЦИАН.ЖУРНАЛ **/
  magazineLinks?: IMagazineLinksSchema | null;
  /** Ссылки на ипотеку **/
  mortgageLinks?: IMortgageLinksSchema | null;
  /** Количество непрочитанных уведомлений **/
  notificationsCount: number;
  /** Ссылки не вошедшие в какую-либо категорию **/
  otherLinks?: IOtherLinksSchema | null;
  /** Номер телефона пользователя **/
  phone?: string | null;
  /** RealtyID пользователя **/
  realtyUserId?: number | null;
  /** Ссылка на каталог ТЦ **/
  scUrl?: string | null;
  /** Ссылка на выдачу вторичной **/
  secondaryUrl: string;
  /** Показывать ли баланс **/
  showBalance: boolean;
  /** Показывать ли ссылку на статистику по звонкам **/
  showCallsStatisticsLink: boolean;
  /** Количество сохраненных поисков **/
  storedFiltersCount: number;
  /** CianID пользователя **/
  userId?: number | null;
  /** Результат проверки ограничений **/
  userVerification?: IUserVerificationSchema | null;
  /** Ссылка на каталог КП **/
  villagesUrl: string;
  /** Ссылка на каталог СК **/
  wcUrl?: string | null;
}

export enum ELkType {
  /** Собственник **/
  Homeowner = 'homeowner',
  /** Поискун **/
  Searcher = 'searcher',
  /** Специалист **/
  Specialist = 'specialist',
}
